export default __webpack_public_path__ + "static/media/warehousing.7fa13e32.jpg";